import styled from 'styled-components';

import { theme } from '../../configs';

const Container = styled.div`
  width: 100%;
  max-width: ${theme.size.container}px;
  padding-left: ${theme.size.space * 2}px !important;
  padding-right: ${theme.size.space * 2}px !important;
  margin-left: auto;
  margin-right: auto;
`;

export default Container;
